import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

const PRIVATE_ROUTES = ['/dashboard', '/admin'];

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  // Don't show on dashboard/admin/auth pages
  const isPrivatePage = PRIVATE_ROUTES.some(r => location.pathname.startsWith(r));

  useEffect(() => {
    const consent = localStorage.getItem('whisper-cookie-consent');
    if (!consent && !isPrivatePage) setVisible(true);
    if (consent) setVisible(false);
  }, [isPrivatePage]);

  const accept = () => {
    localStorage.setItem('whisper-cookie-consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('whisper-cookie-consent', 'declined');
    setVisible(false);
    window['ga-disable-G-6BZ2HL98Y5'] = true;
  };

  if (!visible || isPrivatePage) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] pointer-events-none" data-testid="cookie-consent">
      <div className="max-w-lg mx-auto pointer-events-auto bg-card border border-border rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.15)] p-4 backdrop-blur-xl" style={{ animation: 'slideUp 0.4s ease' }}>
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg bg-[#10B981]/10 flex items-center justify-center shrink-0 mt-0.5">
            <Cookie className="h-4 w-4 text-[#10B981]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground leading-relaxed">
              We use cookies to improve your experience and analyze traffic.{' '}
              <a href="/privacy" className="text-[#10B981] hover:underline">Privacy</a> &middot;{' '}
              <a href="/cookies" className="text-[#10B981] hover:underline">Cookies</a>
            </p>
            <div className="flex items-center gap-2 mt-2.5">
              <Button size="sm" onClick={accept} className="bg-[#10B981] hover:bg-[#059669] text-white text-xs h-7 px-3" data-testid="cookie-accept-btn">
                Accept
              </Button>
              <Button size="sm" variant="outline" onClick={decline} className="text-xs h-7 px-3" data-testid="cookie-decline-btn">
                Decline
              </Button>
            </div>
          </div>
          <button onClick={decline} className="text-muted-foreground hover:text-foreground shrink-0" data-testid="cookie-close-btn">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
